<template lang="pug">
div.main-container(:class="this.template + ' ' + this.classes")
  navigation
  main.page(class="landing")
    //- TODO: bind landing class to page-level (i.e top level or not)
    section#opening.row(v-if="this.title || this.desc || this.image")
      .page-header
        h1(v-if="this.title")
          vue-markdown(:source='this.title')
        vue-markdown.desc(:source='this.desc' v-if="this.desc")
      div.hero(v-if="this.image")
        <img :src='this.image && this.image.fields.file.url' :alt='this.image && this.image.fields.file.fileName' />

    //- FIXME: hardcoded class condition..
    //- section(v-for="(n, i) in this.sections" :class="n.fields.templateId != 'page-footer' && 'row'")
    section(v-for="(n, i) in this.sections" class="row" :key="'section-'+n.sys.id")
      component(:is="kebabToCamel(n.fields.templateId)" :payload="n" :key="n.sys.id")
    section(class="row fullwidth sitefooter")
      pageFooter(v-if="this.pageFooter" :domainInfo="this.appData.root.fields" :payload="this.pageFooter")
</template>

<script>
import pageBase from '@/scenes/_pageBase.js'

export default {
  name: 'PageScene',
  mixins: [pageBase],
  components: {},
  data: function () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}

</script>

<style lang="scss">
.article {
  img{
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/scenes/pageScene.vue